import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface DrRow {
  readonly drTestId: string;
  readonly drTestReference: string;
  readonly testName: string;
  readonly status: string;
  readonly rpoMet: boolean | null;
  readonly rtoMet: boolean | null;
}

export function M19DrDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<DrRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: DrRow[] }>('/v1/platform/dr-tests', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m19.dr.loading')}</p>;
  return (
    <main aria-label="dr-dashboard">
      <h1>{t('m19.dr.title')}</h1>
      <table aria-label="dr-tests-table">
        <thead><tr><th>{t('m19.dr.colReference')}</th><th>{t('m19.dr.colTest')}</th><th>{t('m19.dr.colStatus')}</th><th>{t('m19.dr.colRpoMet')}</th><th>{t('m19.dr.colRtoMet')}</th></tr></thead>
        <tbody>
          {rows.map((d) => (
            <tr key={d.drTestId}>
              <td>{d.drTestReference}</td>
              <td>{d.testName}</td>
              <td>{d.status}</td>
              <td>{d.rpoMet == null ? '—' : d.rpoMet ? t('m19.dr.yes') : t('m19.dr.no')}</td>
              <td>{d.rtoMet == null ? '—' : d.rtoMet ? t('m19.dr.yes') : t('m19.dr.no')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
